import { CSSObjectWithLabel } from '@atlaskit/react-select';
import { token } from '@atlaskit/tokens';

type StateProps = {
  isFocused: boolean;
};

export const subtleSelector = (css: CSSObjectWithLabel, state: StateProps) => ({
  backgroundColor: state.isFocused ? css.backgroundColor : 'transparent',
  borderColor: state.isFocused ? css.borderColor : 'transparent',
});

export const nothingSelectedColor = () => ({
  color: token('color.text.subtle'),
});
